exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: (minmax(0, 1fr))[6];\n      grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 10px; }\n  :host * {\n    box-sizing: border-box; }\n\n.cd-kpi {\n  border: 1px solid #e3e7ee;\n  padding: 10px 14px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  gap: 2px;\n  min-width: 0; }\n  .cd-kpi__label {\n    font-size: 0.92857rem;\n    color: #343a40; }\n  .cd-kpi__value, .cd-kpi__sub {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n  .cd-kpi__value {\n    font-size: 1.85714rem;\n    font-weight: 700;\n    color: #000;\n    line-height: 1.15; }\n  .cd-kpi__sub {\n    font-size: 0.85714rem; }\n\n.cd-tone--bad {\n  color: #dc3545; }\n\n.cd-tone--good {\n  color: #28a745; }\n\n.cd-tone--neutral {\n  color: #6c757d; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/complaints/complaints-dashboard/components/dashboard-kpis/dashboard-kpis.component.scss
// module id = 1993
// module chunks = 66